module.exports = __webpack_public_path__ + "static/media/capitalsphere_interview3.06be3aad.svg";